import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { formatDate } from "../../../utils/dateFormat";
import { ProductContext } from "../../../Contexts/ProductContext";
import axios from "axios";

const columns = [
  { id: "userid", label: "#", minWidth: 100 },
  { id: "prdTitle", label: "Product Title", minWidth: 170 },
  { id: "prdImage", label: "Image", minWidth: 170 },
  { id: "prdCategory", label: "Category", minWidth: 170 },
  { id: "prdStock", label: "Stock", minWidth: 170 },
  { id: "createdAt", label: "Created At", minWidth: 170 },
  { id: "action", label: "Action", minWidth: 170 },
];

const AllProducts = () => {
  const { products, fetchProducts } = React.useContext(ProductContext);
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.state && location.state.message) {
      toast.success(location.state.message);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, navigate]);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const sortedProducts = products.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleDelete = async (productId) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        const response = await axios.delete(
          `${apiUrl}deleteProduct/${productId}`
        );
        if (response.status === 200) {
          toast.success("Product deleted successfully.");
          fetchProducts();
        } else {
          toast.error("Failed to delete product.");
        }
      } catch (error) {
        console.error("Error deleting product:", error);
        toast.error("Error deleting product.");
      }
    }
  };

  return (
    <div className="dashboard-content-wrap p-10">
      <ToastContainer />
      <div className="box-card">
        <div className="box-card-title mb-4">
          <h1 className="text-lg font-medium flex items-center">
            All Products
          </h1>
          <Link className="btn-main-dash" to="/admin/dashboard/addproduct">
            Add New Product
            <AddOutlinedIcon sx={{ fontSize: "19px", color: "#fff" }} />
          </Link>
        </div>
        <div className="box-card-body">
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedProducts.map((product, index) => (
                    <TableRow hover key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{product.title}</TableCell>
                      <TableCell>
                        <img
                          src={product.images ? product.images[0] : "No Image"}
                          className="h-[100px] w-[100px] object-cover rounded-md"
                        />
                      </TableCell>
                      <TableCell>
                        {product.prdCategory === "Buy" ? (
                          <span className="pCtg-green">For Sale</span>
                        ) : (
                          <span className="pCtg-red">For Rent</span>
                        )}
                      </TableCell>
                      <TableCell>
                        {product.prdStock === "In Stock" ? (
                          <span className="pstk-green">In Stock</span>
                        ) : (
                          <span className="pstk-red">Out of Stock</span>
                        )}
                      </TableCell>
                      <TableCell>{formatDate(product.createdAt)}</TableCell>
                      <TableCell>
                        <Link
                          to={`/admin/dashboard/editProduct/${product._id}`}
                        >
                          <EditOutlinedIcon />
                        </Link>

                        <DeleteForeverOutlinedIcon
                          onClick={() => handleDelete(product._id)}
                          style={{ cursor: "pointer", color: "red" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={products.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default AllProducts;
